export { TakeActionLandingPageV2 } from './TakeActionLandingPageV2';
